export default "__VITE_ASSET__CXrF6QdX__"